<div class="cw-layout">
  <app-workbench-header></app-workbench-header>
  <main class="cw-layout__main" aria-labelledby="pending-list-title">
    <header class="cw-page-head">
      <div>
        <nav class="cw-breadcrumb" [attr.aria-label]="'pending_approval_jobs_title' | translate">
          <a routerLink="/pendingapprovaljobs/summary">{{ "pending_approval_jobs_title" | translate }}</a>
          <span aria-hidden="true">/</span>
          <span aria-current="page">{{ siteName || ("open_jobs_summary_unknown_site" | translate) }} - {{ titleKey | translate }}</span>
        </nav>
        <h1 class="cw-page-head__title" id="pending-list-title">{{ siteName || ("open_jobs_summary_unknown_site" | translate) }} - {{ titleKey | translate }}</h1>
      </div>
      <div class="cw-thinksafe">
        <img class="cw-thinksafe__logo" src="/assets/thinksafe-logo.png" alt="ThinkSafe" />
        <span class="cw-thinksafe__link">{{ "pending_approval_jobs_health_safety" | translate }}</span>
      </div>
    </header>

    <section class="cw-table-card cw-card" [attr.aria-label]="titleKey | translate">
      <div class="cw-table-card__scroll">
        <table class="cw-table cw-jobs-table">
          <thead>
            <tr>
              <th class="cw-table__head-cell cw-jobs-table__id" scope="col">{{ "open_jobs_list_job_id" | translate }}</th>
              <th class="cw-table__head-cell cw-jobs-table__date" scope="col">{{ "open_jobs_list_callout_date" | translate }}</th>
              <th class="cw-table__head-cell" scope="col">{{ "open_jobs_list_fault_service" | translate }}</th>
              <th class="cw-table__head-cell" scope="col">{{ "open_jobs_list_notes" | translate }}</th>
              <th class="cw-table__head-cell" scope="col">{{ "open_jobs_list_allocated_to" | translate }}</th>
              <th class="cw-table__head-cell cw-jobs-table__date" scope="col">{{ "open_jobs_list_allocated_on" | translate }}</th>
              <th class="cw-table__head-cell cw-jobs-table__work-order" scope="col">{{ "open_jobs_list_work_order" | translate }}</th>
              <th class="cw-table__head-cell cw-jobs-table__actions" scope="col">{{ "open_jobs_list_action" | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @if (isLoading()) {
              <tr><td class="cw-table__empty" colspan="8" role="status">{{ "signin_lbl_loading_jobs" | translate }}</td></tr>
            } @else if (hasLoadError()) {
              <tr><td class="cw-table__empty" colspan="8" role="alert">{{ "pending_approval_jobs_load_failed" | translate }}</td></tr>
            } @else {
            @for (job of jobs(); track job.id; let alternate = $odd) {
              <tr class="cw-table__row" [class.cw-job-row--alternate]="alternate">
                <td class="cw-table__cell cw-table__cell--lead" [attr.data-label]="'open_jobs_list_job_id' | translate">
                  <button type="button" class="job-id-link">{{ job.referenceNumber || ("open_jobs_summary_not_available" | translate) }}</button>
                </td>
                <td class="cw-table__cell" [attr.data-label]="'open_jobs_list_callout_date' | translate">{{ "open_jobs_summary_not_available" | translate }}</td>
                <td class="cw-table__cell cw-table__cell--wrap" [attr.data-label]="'open_jobs_list_fault_service' | translate">
                  <span>{{ job.faultServiceName || ("open_jobs_summary_not_available" | translate) }}</span>
                </td>
                <td class="cw-table__cell cw-table__cell--wrap" [attr.data-label]="'open_jobs_list_notes' | translate">
                  <span>{{ job.notes || ("open_jobs_summary_not_available" | translate) }}</span>
                </td>
                <td class="cw-table__cell cw-table__cell--wrap" [attr.data-label]="'open_jobs_list_allocated_to' | translate">
                  <div class="cw-allocation">
                    <span class="cw-allocation__company"><strong>{{ "open_jobs_list_company_name" | translate }}:</strong> {{ "open_jobs_summary_not_available" | translate }}</span>
                    <div class="cw-allocation__contact">
                      <span><strong>{{ "open_jobs_list_contact" | translate }}:</strong> {{ "open_jobs_summary_not_available" | translate }}, {{ job.allocatedUserEmail || ("open_jobs_summary_not_available" | translate) }}, {{ "open_jobs_summary_not_available" | translate }}</span>
                    </div>
                    <a class="cw-chip cw-allocation__status" [routerLink]="['/openpendingapprovaljobs', job.id]"
                      [queryParams]="{ siteId: siteId, siteName: siteName, jobType: listJobType }">{{ "pending_approval_list_status" | translate }}</a>
                  </div>
                </td>
                <td class="cw-table__cell" [attr.data-label]="'open_jobs_list_allocated_on' | translate">{{ "open_jobs_summary_not_available" | translate }}</td>
                <td class="cw-table__cell" [attr.data-label]="'open_jobs_list_work_order' | translate">
                  @if (job.workOrderNumber) {
                    <button type="button" class="cw-button cw-button--secondary cw-download-button" [attr.aria-label]="('open_jobs_list_download' | translate) + ' - ' + job.referenceNumber"><mat-icon aria-hidden="true">download</mat-icon>{{ "open_jobs_list_download" | translate }}</button>
                  } @else {
                    {{ "open_jobs_summary_not_available" | translate }}
                  }
                </td>
                <td class="cw-table__cell cw-table__cell--actions" [attr.data-label]="'open_jobs_list_action' | translate">
                  <div class="cw-table__actions">
                    <button type="button" class="cw-button cw-button--secondary" [attr.aria-label]="('open_jobs_list_allocate_to' | translate) + ' - ' + job.referenceNumber">{{ "open_jobs_list_allocate_to" | translate }}</button>
                  </div>
                </td>
              </tr>
            } @empty {
              <tr><td class="cw-table__empty" colspan="8">{{ "open_jobs_summary_empty" | translate }}</td></tr>
            }
            }
          </tbody>
        </table>
      </div>
    </section>
  </main>
  <app-workbench-footer></app-workbench-footer>
</div>
